import React from 'react'
import { Grid, GridProps, GridSpacing } from '@material-ui/core'

interface IFormWrapper extends GridProps {
  spacing?: GridSpacing
}

const FormWrapper: React.FC<IFormWrapper> = ({ children, spacing, ...props }) => {
  return (
    <Grid container spacing={spacing === undefined ? 2 : spacing} {...props}>
      {children}
    </Grid>
  )
}

export default FormWrapper
